import React from 'react';
import { Icon } from '../../shared/Icon';

export function DrillCruxCallout({
  kicker,
  text,
  tone = 'neutral',
  compact = false,
}: {
  kicker?: string;
  text: string;
  tone?: 'good' | 'bad' | 'neutral';
  compact?: boolean;
}) {
  const color =
    tone === 'good'
      ? 'var(--st-steady)'
      : tone === 'bad'
        ? 'var(--st-alert)'
        : 'var(--ink-3)';
  return (
    <div
      className={`dcrux-callout dcrux-callout-${tone}${compact ? ' is-compact' : ''}`}
    >
      {kicker ? (
        <span className="dcrux-callout-kicker" style={{ color }}>
          <Icon
            name={tone === 'bad' ? 'flag' : tone === 'good' ? 'check' : 'target'}
            size={11}
          />
          {kicker}
        </span>
      ) : null}
      <span className="dcrux-callout-text">{text}</span>
    </div>
  );
}
